/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineDocumentCreateModel,
    MachineDocumentCreateModelFromJSON,
    MachineDocumentCreateModelFromJSONTyped,
    MachineDocumentCreateModelToJSON,
} from './MachineDocumentCreateModel';
import {
    MachineRentalTypeCreateModel,
    MachineRentalTypeCreateModelFromJSON,
    MachineRentalTypeCreateModelFromJSONTyped,
    MachineRentalTypeCreateModelToJSON,
} from './MachineRentalTypeCreateModel';

/**
 * 
 * @export
 * @interface MachineCreateModel
 */
export interface MachineCreateModel {
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    lessorCompanyId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    brandId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    brandOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    attachmentOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    modelName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    productionYear?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operationMileage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operationHour?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    drivingEquipment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    enginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    tankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    fuelTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    elevatorTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operatingArea?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operatingLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operationWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operatingCapacity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    usageFields?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    hasCabin?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    engineBrand?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    hasPlatform?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    hasTowerElevationSystem?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    lightningCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    carryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    width?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    volume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    floorCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    liftingHeight?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    saleNotes?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    hasOperator?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    operatorExperienceYear?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    shipingIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    operatorCostIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    operatorInsuranceIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    fuelIncluded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    bladeWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    frequency?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    minPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    nominalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    waterTankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxFeedingSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    workingSpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    cleaningCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    garbageCollectionBin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    breakingInfo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    bomLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxDepth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    compressionWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    platformLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    platformWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    concretePumpingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    maxPressure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    freeAirOutput?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    spraySpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    tankVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    loadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    cameraResolutionId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    flightTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    flightDistance?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    workingRadius?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineCreateModel
     */
    isMachineForSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    machineId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    machineSalePrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    machineSalePriceCurrencyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineCreateModel
     */
    machineLocationCityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    rentalAdTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineCreateModel
     */
    saleAdTitle?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineCreateModel
     */
    serviceRegions?: Array<number> | null;
    /**
     * 
     * @type {Array<MachineDocumentCreateModel>}
     * @memberof MachineCreateModel
     */
    documents?: Array<MachineDocumentCreateModel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineCreateModel
     */
    attachments?: Array<number> | null;
    /**
     * 
     * @type {Array<MachineRentalTypeCreateModel>}
     * @memberof MachineCreateModel
     */
    rentalTypes?: Array<MachineRentalTypeCreateModel> | null;
}

export function MachineCreateModelFromJSON(json: any): MachineCreateModel {
    return MachineCreateModelFromJSONTyped(json, false);
}

export function MachineCreateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineCreateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lessorCompanyId': !exists(json, 'lessorCompanyId') ? undefined : json['lessorCompanyId'],
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'brandId': !exists(json, 'brandId') ? undefined : json['brandId'],
        'brandOther': !exists(json, 'brandOther') ? undefined : json['brandOther'],
        'attachmentOther': !exists(json, 'attachmentOther') ? undefined : json['attachmentOther'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'productionYear': !exists(json, 'productionYear') ? undefined : json['productionYear'],
        'operationMileage': !exists(json, 'operationMileage') ? undefined : json['operationMileage'],
        'operationHour': !exists(json, 'operationHour') ? undefined : json['operationHour'],
        'drivingEquipment': !exists(json, 'drivingEquipment') ? undefined : json['drivingEquipment'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'operatingWeight': !exists(json, 'operatingWeight') ? undefined : json['operatingWeight'],
        'tankCapacity': !exists(json, 'tankCapacity') ? undefined : json['tankCapacity'],
        'fuelTypeId': !exists(json, 'fuelTypeId') ? undefined : json['fuelTypeId'],
        'elevatorTypeId': !exists(json, 'elevatorTypeId') ? undefined : json['elevatorTypeId'],
        'operatingHeight': !exists(json, 'operatingHeight') ? undefined : json['operatingHeight'],
        'operatingArea': !exists(json, 'operatingArea') ? undefined : json['operatingArea'],
        'operatingLength': !exists(json, 'operatingLength') ? undefined : json['operatingLength'],
        'operationWidth': !exists(json, 'operationWidth') ? undefined : json['operationWidth'],
        'operatingCapacity': !exists(json, 'operatingCapacity') ? undefined : json['operatingCapacity'],
        'usageFields': !exists(json, 'usageFields') ? undefined : json['usageFields'],
        'hasCabin': !exists(json, 'hasCabin') ? undefined : json['hasCabin'],
        'engineBrand': !exists(json, 'engineBrand') ? undefined : json['engineBrand'],
        'hasPlatform': !exists(json, 'hasPlatform') ? undefined : json['hasPlatform'],
        'hasTowerElevationSystem': !exists(json, 'hasTowerElevationSystem') ? undefined : json['hasTowerElevationSystem'],
        'lightningCapacity': !exists(json, 'lightningCapacity') ? undefined : json['lightningCapacity'],
        'carryingCapacity': !exists(json, 'carryingCapacity') ? undefined : json['carryingCapacity'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'volume': !exists(json, 'volume') ? undefined : json['volume'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'floorCount': !exists(json, 'floorCount') ? undefined : json['floorCount'],
        'liftingHeight': !exists(json, 'liftingHeight') ? undefined : json['liftingHeight'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'saleNotes': !exists(json, 'saleNotes') ? undefined : json['saleNotes'],
        'hasOperator': !exists(json, 'hasOperator') ? undefined : json['hasOperator'],
        'operatorExperienceYear': !exists(json, 'operatorExperienceYear') ? undefined : json['operatorExperienceYear'],
        'shipingIncluded': !exists(json, 'shipingIncluded') ? undefined : json['shipingIncluded'],
        'operatorCostIncluded': !exists(json, 'operatorCostIncluded') ? undefined : json['operatorCostIncluded'],
        'operatorInsuranceIncluded': !exists(json, 'operatorInsuranceIncluded') ? undefined : json['operatorInsuranceIncluded'],
        'fuelIncluded': !exists(json, 'fuelIncluded') ? undefined : json['fuelIncluded'],
        'bladeWidth': !exists(json, 'bladeWidth') ? undefined : json['bladeWidth'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'minPower': !exists(json, 'minPower') ? undefined : json['minPower'],
        'maxPower': !exists(json, 'maxPower') ? undefined : json['maxPower'],
        'maxLoadCapacity': !exists(json, 'maxLoadCapacity') ? undefined : json['maxLoadCapacity'],
        'nominalCapacity': !exists(json, 'nominalCapacity') ? undefined : json['nominalCapacity'],
        'waterTankCapacity': !exists(json, 'waterTankCapacity') ? undefined : json['waterTankCapacity'],
        'maxFeedingSize': !exists(json, 'maxFeedingSize') ? undefined : json['maxFeedingSize'],
        'workingSpeed': !exists(json, 'workingSpeed') ? undefined : json['workingSpeed'],
        'cleaningCapacity': !exists(json, 'cleaningCapacity') ? undefined : json['cleaningCapacity'],
        'garbageCollectionBin': !exists(json, 'garbageCollectionBin') ? undefined : json['garbageCollectionBin'],
        'breakingInfo': !exists(json, 'breakingInfo') ? undefined : json['breakingInfo'],
        'bomLength': !exists(json, 'bomLength') ? undefined : json['bomLength'],
        'maxHeight': !exists(json, 'maxHeight') ? undefined : json['maxHeight'],
        'maxDepth': !exists(json, 'maxDepth') ? undefined : json['maxDepth'],
        'maxWidth': !exists(json, 'maxWidth') ? undefined : json['maxWidth'],
        'compressionWidth': !exists(json, 'compressionWidth') ? undefined : json['compressionWidth'],
        'platformLength': !exists(json, 'platformLength') ? undefined : json['platformLength'],
        'platformWidth': !exists(json, 'platformWidth') ? undefined : json['platformWidth'],
        'concretePumpingCapacity': !exists(json, 'concretePumpingCapacity') ? undefined : json['concretePumpingCapacity'],
        'maxPressure': !exists(json, 'maxPressure') ? undefined : json['maxPressure'],
        'freeAirOutput': !exists(json, 'freeAirOutput') ? undefined : json['freeAirOutput'],
        'spraySpeed': !exists(json, 'spraySpeed') ? undefined : json['spraySpeed'],
        'tankVolume': !exists(json, 'tankVolume') ? undefined : json['tankVolume'],
        'loadCapacity': !exists(json, 'loadCapacity') ? undefined : json['loadCapacity'],
        'cameraResolutionId': !exists(json, 'cameraResolutionId') ? undefined : json['cameraResolutionId'],
        'flightTime': !exists(json, 'flightTime') ? undefined : json['flightTime'],
        'flightDistance': !exists(json, 'flightDistance') ? undefined : json['flightDistance'],
        'workingRadius': !exists(json, 'workingRadius') ? undefined : json['workingRadius'],
        'isMachineForSale': !exists(json, 'isMachineForSale') ? undefined : json['isMachineForSale'],
        'machineId': !exists(json, 'machineId') ? undefined : json['machineId'],
        'machineSalePrice': !exists(json, 'machineSalePrice') ? undefined : json['machineSalePrice'],
        'machineSalePriceCurrencyId': !exists(json, 'machineSalePriceCurrencyId') ? undefined : json['machineSalePriceCurrencyId'],
        'machineLocationCityId': !exists(json, 'machineLocationCityId') ? undefined : json['machineLocationCityId'],
        'rentalAdTitle': !exists(json, 'rentalAdTitle') ? undefined : json['rentalAdTitle'],
        'saleAdTitle': !exists(json, 'saleAdTitle') ? undefined : json['saleAdTitle'],
        'serviceRegions': !exists(json, 'serviceRegions') ? undefined : json['serviceRegions'],
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : (json['documents'] as Array<any>).map(MachineDocumentCreateModelFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'rentalTypes': !exists(json, 'rentalTypes') ? undefined : (json['rentalTypes'] === null ? null : (json['rentalTypes'] as Array<any>).map(MachineRentalTypeCreateModelFromJSON)),
    };
}

export function MachineCreateModelToJSON(value?: MachineCreateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lessorCompanyId': value.lessorCompanyId,
        'subCategoryId': value.subCategoryId,
        'brandId': value.brandId,
        'brandOther': value.brandOther,
        'attachmentOther': value.attachmentOther,
        'modelName': value.modelName,
        'productionYear': value.productionYear,
        'operationMileage': value.operationMileage,
        'operationHour': value.operationHour,
        'drivingEquipment': value.drivingEquipment,
        'enginePower': value.enginePower,
        'operatingWeight': value.operatingWeight,
        'tankCapacity': value.tankCapacity,
        'fuelTypeId': value.fuelTypeId,
        'elevatorTypeId': value.elevatorTypeId,
        'operatingHeight': value.operatingHeight,
        'operatingArea': value.operatingArea,
        'operatingLength': value.operatingLength,
        'operationWidth': value.operationWidth,
        'operatingCapacity': value.operatingCapacity,
        'usageFields': value.usageFields,
        'hasCabin': value.hasCabin,
        'engineBrand': value.engineBrand,
        'hasPlatform': value.hasPlatform,
        'hasTowerElevationSystem': value.hasTowerElevationSystem,
        'lightningCapacity': value.lightningCapacity,
        'carryingCapacity': value.carryingCapacity,
        'width': value.width,
        'volume': value.volume,
        'height': value.height,
        'floorCount': value.floorCount,
        'liftingHeight': value.liftingHeight,
        'notes': value.notes,
        'saleNotes': value.saleNotes,
        'hasOperator': value.hasOperator,
        'operatorExperienceYear': value.operatorExperienceYear,
        'shipingIncluded': value.shipingIncluded,
        'operatorCostIncluded': value.operatorCostIncluded,
        'operatorInsuranceIncluded': value.operatorInsuranceIncluded,
        'fuelIncluded': value.fuelIncluded,
        'bladeWidth': value.bladeWidth,
        'frequency': value.frequency,
        'minPower': value.minPower,
        'maxPower': value.maxPower,
        'maxLoadCapacity': value.maxLoadCapacity,
        'nominalCapacity': value.nominalCapacity,
        'waterTankCapacity': value.waterTankCapacity,
        'maxFeedingSize': value.maxFeedingSize,
        'workingSpeed': value.workingSpeed,
        'cleaningCapacity': value.cleaningCapacity,
        'garbageCollectionBin': value.garbageCollectionBin,
        'breakingInfo': value.breakingInfo,
        'bomLength': value.bomLength,
        'maxHeight': value.maxHeight,
        'maxDepth': value.maxDepth,
        'maxWidth': value.maxWidth,
        'compressionWidth': value.compressionWidth,
        'platformLength': value.platformLength,
        'platformWidth': value.platformWidth,
        'concretePumpingCapacity': value.concretePumpingCapacity,
        'maxPressure': value.maxPressure,
        'freeAirOutput': value.freeAirOutput,
        'spraySpeed': value.spraySpeed,
        'tankVolume': value.tankVolume,
        'loadCapacity': value.loadCapacity,
        'cameraResolutionId': value.cameraResolutionId,
        'flightTime': value.flightTime,
        'flightDistance': value.flightDistance,
        'workingRadius': value.workingRadius,
        'isMachineForSale': value.isMachineForSale,
        'machineId': value.machineId,
        'machineSalePrice': value.machineSalePrice,
        'machineSalePriceCurrencyId': value.machineSalePriceCurrencyId,
        'machineLocationCityId': value.machineLocationCityId,
        'rentalAdTitle': value.rentalAdTitle,
        'saleAdTitle': value.saleAdTitle,
        'serviceRegions': value.serviceRegions,
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : (value.documents as Array<any>).map(MachineDocumentCreateModelToJSON)),
        'attachments': value.attachments,
        'rentalTypes': value.rentalTypes === undefined ? undefined : (value.rentalTypes === null ? null : (value.rentalTypes as Array<any>).map(MachineRentalTypeCreateModelToJSON)),
    };
}

